import { render } from "./VariantsComponent.vue?vue&type=template&id=588afca2"
import script from "./VariantsComponent.vue?vue&type=script&lang=js"
export * from "./VariantsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__